(() => {
  const gridSelector = '.kanela-filter-app__grid';
  const cardSelector = `${gridSelector} .product-card`;
  const badgeCache = new Map();

  const getProductHandle = (card) => {
    const productLink = card.querySelector('.product-card__title a[href*="/products/"]');
    if (!productLink) return null;

    const match = new URL(productLink.href, window.location.origin).pathname.match(/^\/products\/([^/]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  };

  const fetchBadge = (handle) => {
    if (!badgeCache.has(handle)) {
      const badgeRequest = fetch(`/products/${encodeURIComponent(handle)}?section_id=niccos-judgeme-badge`, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Judge.me badge request failed: ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          return documentFragment.querySelector('.jdgm-preview-badge');
        })
        .catch(() => null);

      badgeCache.set(handle, badgeRequest);
    }

    return badgeCache.get(handle);
  };

  const loadBadge = async (card) => {
    if (card.dataset.judgemeBadgeStatus) return;

    const placeholder = card.querySelector('.ruk_rating_snippet');
    const title = card.querySelector('.product-card__title');
    const handle = getProductHandle(card);
    if (!title || !handle) return;

    card.dataset.judgemeBadgeStatus = 'loading';
    const badgeTemplate = await fetchBadge(handle);

    if (!card.isConnected) return;

    if (badgeTemplate) {
      const badge = badgeTemplate.cloneNode(true);
      if (placeholder) {
        placeholder.replaceWith(badge);
      } else {
        title.insertAdjacentElement('afterend', badge);
      }
      card.dataset.judgemeBadgeStatus = 'loaded';
      document.dispatchEvent(new CustomEvent('jdgm.refresh'));
    } else {
      card.dataset.judgemeBadgeStatus = 'empty';
      placeholder?.remove();
    }
  };

  const observeCard = (card) => {
    if (card.dataset.judgemeBadgeObserved) return;
    card.dataset.judgemeBadgeObserved = 'true';

    if (!('IntersectionObserver' in window)) {
      loadBadge(card);
      return;
    }

    cardObserver.observe(card);
  };

  const cardObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            loadBadge(entry.target);
          });
        },
        { rootMargin: '500px 0px' }
      )
    : null;

  const scanCards = () => document.querySelectorAll(cardSelector).forEach(observeCard);

  const start = () => {
    scanCards();
    new MutationObserver(scanCards).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
